import React from 'react';
import {Container, Text} from '@inlet/react-pixi';
import {Slider} from './Slider';
import {TextStyle} from 'pixi.js';

type SliderWithTitleProps = {
    title: string;
    value: number;
    width: number;
    height: number;
    min: number;
    max: number;
    step?: number;
    onChange: (value: number) => void;
};

const style = new TextStyle({
    fontFamily: 'Arial',
    fontSize: 80,
    fontWeight: 'bold',
    align: 'center',
    fill: '#ffffff'
});

export class SliderWithTitle extends React.Component<SliderWithTitleProps> {
    public render(): JSX.Element {
        const {value, onChange, height, max, min, width, step, title} = this.props;

        return (
            <Container>
                <Text x={width / 2} text={title} anchor={[0.5, 0]} style={style}/>
                <Slider thumbSize={80} y={150} width={width} height={height} max={max} min={min} step={step} value={value}
                    onChange={onChange}
                />
                <Text x={width + 80} y={150 + height / 2} text={value.toString()} anchor={[0, 0.5]} style={style}/>
            </Container>
        );
    }
}
